export default __webpack_public_path__ + "static/media/change_icon2.afa469de.svg";